import React from "react";
import styled from "styled-components";

const Wrapper = styled.div`
  width: 100%;
  max-width: var(--container);
  margin: 0 auto;
  padding: 0 var(--gutter);
`;

export const Container = ({ children }) => {
  return <Wrapper>{children}</Wrapper>;
};
